









































































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import {
  IStaff,
  IStaffCreateRequest,
  IStaffUpdateRequest,
} from "@/types/staff";
import { StaffCreateRequest, StaffUpdateRequest } from "@/models/staff";

@Component({
  components: {},
})
export default class extends Vue {
  @Action("staff/salesCreate")
  public create!: (daatas: {
    partner_id: number;
    params: IStaffCreateRequest;
  }) => Promise<boolean>;

  @Action("staff/salesGet")
  public getStaff!: (id: number) => Promise<void>;

  @Action("staff/salesUpdate")
  public update!: (data: {
    staff_id: number;
    params: IStaffUpdateRequest;
  }) => Promise<boolean>;

  @Action("staff/salesDelete")
  public delete!: (id: number) => Promise<boolean>;

  @Getter("staff/single")
  public staff!: IStaff;

  @Mutation("staff/clear")
  public clear!: () => void;

  @Getter("error/error")
  public getError!: (key: string) => string[];

  public partner_id = 0;
  public staff_id = 0;
  public dialog = false;

  public params: IStaffCreateRequest = new StaffCreateRequest();

  private async created() {
    this.partner_id = Number(this.$route.params.partner_id);
    this.staff_id = Number(this.$route.params.staff_id);

    this.clear();

    if (this.staff_id) {
      await this.getStaff(this.staff_id);
      this.params = new StaffUpdateRequest(this.staff);
    }
  }

  public async submit(): Promise<void> {
    let result = false;
    if (this.staff_id) {
      result = await this.update({
        staff_id: this.staff_id,
        params: this.params,
      });
    } else {
      result = await this.create({
        partner_id: this.partner_id,
        params: this.params,
      });
    }
    if (result) {
      this.$router.go(-1);
    }
  }

  public async destroy(): Promise<void> {
    const result = await this.delete(this.staff_id);
    if (result) {
      this.$router.go(-1);
    }
  }

  public get rules(): { [key: string]: ((v: string) => true | string)[] } {
    const emailPattern =
      /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]+.[A-Za-z0-9]+$/;

    const telPattern = /^0\d{9,10}$/;

    return {
      name: [
        (v: string) => !!v || "担当者名は必須です",
        (v: string) => v.length <= 255 || "255文字以内で入力してください",
      ],
      email: [
        (v: string) =>
          !v ||
          emailPattern.test(v) ||
          "メールアドレスを正しい形式で入力してください",
      ],
      tel: [
        (v: string) =>
          !v ||
          telPattern.test(v) ||
          "ハイフンなしの電話番号を半角数字で入力してください",
      ],
    };
  }
}
